const QuotationStatus = {
    TODO: 'to-do',
    CONTACTED: 'contacted',
    NOT_INTERESTED: 'not-interested',
    INVOICED: 'invoiced'
};

module.exports = QuotationStatus;